<div class="drawer-icon" [style.top.px]="iconPosition" style="position: fixed; right: 0; transform: translateY(0); z-index: 10000;"
  (mousedown)="onMouseDown($event)" (mouseenter)="isHovering = true" (mouseleave)="isHovering = false">

  <i class="pi pi-filter drawer-icon-btn" [style.opacity]="isShowDialog ? 0.1 : 1"
    [style.pointerEvents]="isShowDialog ? 'none' : 'auto'" (click)="onIconClick()" pTooltip="Quick Filters"
    tooltipPosition="left">
  </i>

</div>


<!-- Drawer -->
<p-drawer [(visible)]="isShowDialog" position="right" [modal]="true" [blockScroll]="true" [style]="{ width: '380px' }"
  [closable]="true" (onHide)="isShowDialog = false">

  <!-- Header -->
  <ng-template pTemplate="header">
    <h2 class="header">Quick Filters</h2>
  </ng-template>

  <!-- Content -->
  <div class="filters-container">

    <!-- Form -->
    <form [formGroup]="shortcutfrom" class="filter-form">

      <div class="field mb-4" *ngIf="isSuperUser">
        <label class="form-label">
          Choose Client <span class="text-red-600">*</span>
        </label>
        <p-select [options]="clientOptions" formControlName="client_id" optionLabel="label" optionValue="value"
          placeholder="Select Client" appendTo="body" (onChange)="onClientChange($event)"
          [panelStyle]="{ width: '342px' }">
        </p-select>
      </div>

      <div class="field mb-4">
        <label class="form-label">
          Choose Application <span class="text-red-600"></span>
        </label>
        <p-select [showClear]="true" [options]="applicationOptions" formControlName="application_id" optionLabel="label"
          optionValue="value" placeholder="Select Application" appendTo="body" (onChange)="onApplicationChange($event)"
          [panelStyle]="{ width: '340px' }">
        </p-select>
      </div>

      <div class="field mb-4">
        <label class="form-label">
          Choose Process <span class="text-red-600"></span>
        </label>
        <p-select [showClear]="true" [options]="processOptions" formControlName="process_type_id" optionLabel="label"
          optionValue="value" placeholder="Select Process" appendTo="body" (onChange)="onProcessChange($event)"
          [panelStyle]="{ width: '340px' }">
        </p-select>
      </div>

      <div class="field mb-4">
        <label class="form-label">
          Choose Customer <span class="text-red-600"></span>
        </label>
        <p-select [showClear]="true" [options]="customerOptions" formControlName="customer_id" optionLabel="label"
          optionValue="value" placeholder="Select Customer" appendTo="body" (onChange)="onCustomerChange($event)"
          [panelStyle]="{ width: '340px' }">
        </p-select>
      </div>

      <div class="field mb-4">
        <label class="form-label">
          Choose Document <span class="text-red-600"></span>
        </label>
        <p-select [showClear]="true" [options]="documentOptions" formControlName="document_id" optionLabel="label"
          optionValue="value" placeholder="Select Document" appendTo="body" [panelStyle]="{ width: '340px' }">
        </p-select>
      </div>

      <!-- <div class="field mb-4" *ngIf="currentRenderedPage == 'Documents'">
        <label class="form-label">
          Choose Process <span class="text-red-600"></span>
        </label>
        <p-select [showClear]="true" [options]="processOptions" formControlName="process_type_id" optionLabel="label"
          optionValue="value" placeholder="Select Process" appendTo="body" [panelStyle]="{ width: '340px' }">
        </p-select>
      </div> -->

    </form>

    <!-- Footer Buttons -->
    <!-- Footer Buttons -->
    <div class="filter-header mt-4 flex justify-end gap-2">
      <button pButton label="Reset" class="p-button-outlined" (click)="onReset()">
      </button>

      <button pButton label="Filter" class="gradient-bg" [disabled]="shortcutfrom.invalid"
        (click)="navigateToDocumentGrid()">
      </button>
    </div>

  </div>
  <div class="text-center">
    <span class="text-xs text-gray-500">* Quick filters are applicable throughout the application except masterdata. file list and dashboard.</span>
  </div>
</p-drawer>